import type {
  FC,
  PropsWithChildren,
} from 'react';
import {
  useSessionSelector,
  selectHasSCForbiddenTag,
} from '../model';

export const NoSCForbiddenTagAllowedOnlyContent: FC<PropsWithChildren> = ({ children }) => {
  const hasSCForbiddenTag = useSessionSelector(selectHasSCForbiddenTag);
  return hasSCForbiddenTag ? null : children;
};